import { IquicInfo, IQuicBlockSpmParams, SpmTag } from './interface';

export function getSpmParams(iquicInfo: IquicInfo, nodeName?: string) {
  const { spmId, spmTag } = getSpmIdAndTag(
    { spmData: iquicInfo?.spmData, bizTagData: iquicInfo?.bizTagData },
    nodeName,
  );
  const spmParams = getIQuicBlockSpmParams({ ...iquicInfo }, nodeName);

  return {
    spmId,
    spmTag,
    spmParams,
  };
}

// 获取spmId和spmTag
export function getSpmIdAndTag(
  { spmData, bizTagData }: Pick<IquicInfo, 'spmData' | 'bizTagData'>,
  nodeName?: string,
) {
  const spmA = spmData?.spma;
  const spmB = spmData?.spmb;
  const spmC = spmData?.spmc;
  const spmCTag = bizTagData?.spmc || '';

  let spmId = `${spmA}.${spmB}.${spmC}`;
  const spmTag: SpmTag = {
    spmc_tag: spmCTag,
  };

  // 传nodeName则为D位
  if (nodeName) {
    const spmD = spmData?.spmd?.[nodeName] || '';
    if (spmD) {
      spmId = `${spmA}.${spmB}.${spmC}.${spmD}`;
    }
    spmTag.spmd_tag = bizTagData?.spmd?.[nodeName] || '';
  }

  return {
    spmId,
    spmTag,
  };
}

export function getIQuicBlockSpmParams(
  iquicInfo: IquicInfo,
  nodeName?: string,
) {
  const iQuicBlockSpmParams: IQuicBlockSpmParams = {
    iquicBlockId: iquicInfo?.blockId || '',
    iquicBlockCode: iquicInfo?.blockCode || '',
    iquicTemplateCode: iquicInfo?.templateCode || '',
    iquicTemplateVersion: iquicInfo?.templateVersion || '',
  };
  if (nodeName) iQuicBlockSpmParams.iquicNodeName = nodeName;
  return iQuicBlockSpmParams;
}
